<template>
    <div id="ventas-esim">

        <b-button :variant="comprarESIMVariant" block @click="$bvModal.show('modal-nuevo-producto')" v-if="buttonOnly">
            {{ comprarESIMLabel }}
        </b-button>

        <b-card v-else :no-body="misProductos.length !== 0">
            <template v-if="misProductos.length !== 0" #header>
                <b-row>
                    <b-col cols="8">
                        <b-form-input v-model="filter" placeholder="Buscar..."></b-form-input>
                    </b-col>
                    <b-col cols="4">
                        <!-- Botón para agregar eSIM -->
                        <b-button :variant="comprarESIMVariant" block @click="$bvModal.show('modal-nuevo-producto')">
                            {{ comprarESIMLabel }}
                        </b-button>
                    </b-col>
                </b-row>
            </template>

            <!-- Lista de productos contratados -->
            <b-jumbotron v-if="misProductos.length === 0">
                <template #header>No tienes números eSIM</template>
                <template #lead>
                    Puedes comprar los que quiereas aquí mismo, solo haz clic en:
                    <hr>
                    <b-button :variant="comprarESIMVariant" block @click="$bvModal.show('modal-nuevo-producto')">
                        {{ comprarESIMLabel }}
                    </b-button>
                </template>
            </b-jumbotron>
            <b-table v-else :items="misProductos" :fields="fields" striped hover>
                <template #cell(acciones)="row">
                    <b-button variant="info" size="sm" @click="verDetalles(row.item)">
                        Ver
                    </b-button>
                </template>
            </b-table>

        </b-card>

        <!-- Modal para nuevo eSIM -->
        <b-modal id="modal-nuevo-producto" :title="comprarESIMLabel" hide-footer @hidden="currentStep = 1; cantidad = 1">
            <b-form @submit.prevent="() => { }">
                <b-form-row>
                    <b-col>
                        <b-form-group label="Seleccione el paquete:">
                            <b-form-select v-model="selectedPaquete" :options="paquetesDisponibles"
                                :disabled="currentStep != 1" />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Cantidad:">
                            <b-form-input type="number" v-model="cantidad" min="1" step="1" max="9999"
                                :disabled="currentStep != 1" />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <template v-if="selectedPaquete">
                    <b-img :src="selectedProductObj.imagenes_id | img" class="mb-3" fluid />
                    <p class="content" v-html="markedDescription"></p>
                    <hr>
                </template>

                <!-- Mostrar subtotal -->
                <template v-if="subtotal">
                    <b-form-row>
                        <b-col>
                            <b-form-group label="Subtotal:">
                                <b-form-input :value="subtotal | currency" readonly />
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                </template>

                <hr>
                <!-- Checkbox de confirmación de compatibilidad -->
                <b-form-group>
                    <b-form-checkbox v-model="isCompatible" :disabled="currentStep != 1">
                        Confirmo que mi dispositivo
                        <b-link href="#/compatibilidad" target="_blank">
                            es compatible
                            <!-- Verificar compatibilidad por IMEI -->
                        </b-link>
                        con la tecnología eSIM.
                    </b-form-checkbox>
                </b-form-group>

                <!-- Componente Stripe -->
                <template v-if="currentStep == 2">
                    <hr>
                    <div class="stripeCardElementId-Class" :id="stripeCardElementId"></div>
                </template>

                <hr>

                <div class="text-right">
                    <b-button variant="secondary" @click="$bvModal.hide('modal-nuevo-producto')">
                        Cancelar
                    </b-button>
                    <b-button variant="primary" v-if="currentStep == 1" @click="currentStep = 2; loadPaymentElements();"
                        :alt="(!isCompatible) ? 'Debes confirmar que tu dispositivo es compatible' : ''"
                        :disabled="!isCompatible">
                        Proceder al pago
                    </b-button>
                    <b-button type="submit" variant="primary" v-else @click="procesarCompra">
                        Finalizar compra
                    </b-button>
                </div>
            </b-form>
        </b-modal>

        <!-- Modal para detalles del producto -->
        <b-modal id="modal-detalles" title="Detalles del producto" ok-only>
            <b-form>

                <img class="modal-detalles-img" :src="productoSeleccionado.imagenes_id | img" />

                <b-form-row>
                    <b-col>
                        <b-form-group label="MSISDN:">
                            <b-form-input v-model="productoSeleccionado.msisdn" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="ICCID:">
                            <b-form-input v-model="productoSeleccionado.icc_id" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col>
                        <b-form-group label="Oferta preactivación:">
                            <b-form-input v-model="productoSeleccionado.ofertaspublicas_id_label" readonly />
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Precio de compra:">
                            <b-form-input v-model="productoSeleccionado.precio_compra" readonly />
                        </b-form-group>
                    </b-col>
                </b-form-row>

                <hr v-if="showUser">

                <b-form-group label="Usuario:" class="hidden" v-if="showUser">
                    <b-form-input v-model="productoSeleccionado.usuarios_id_label" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="Correo electrónico:" class="hidden" v-if="showUser">
                    <b-form-input v-model="productoSeleccionado.email" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="Nombre del cliente:" class="hidden" v-if="showUser">
                    <b-form-input v-model="productoSeleccionado.cliente_full_name" readonly></b-form-input>
                </b-form-group>

                <hr>

                <b-form-row>
                    <b-col>
                        <b-form-group label="Fecha de creación:">
                            <b-form-input v-model="productoSeleccionado.created" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Fecha de modificación:">
                            <b-form-input v-model="productoSeleccionado.modified" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-form-row>

            </b-form>
        </b-modal>
    </div>
</template>

<script>
// import { loadStripe } from '@stripe/stripe-js';
import _ from 'lodash';
import stripeObj from './stripeHandler.js';
import sanitizeHtml from 'sanitize-html';
import axios from 'axios'
import { notify } from '../../../utils.js';

import { marked } from 'marked'

export default {
    name: 'ventasEsim',
    props: {
        buttonOnly: {
            type: Boolean,
            default: true
        },
        comprarESIMLabel: {
            type: String,
            default: 'eSIM'
        },
        comprarESIMVariant: {
            type: String,
            default: 'primary'
        },
        stripeCardElementId: {
            type: String,
            default: 'stripeCardElementId'
        },
        showUser: {
            type: Boolean,
            default: false
        },
        apiLoadUp: {
            type: String,
            default: 'esim/misproductos'
        },
        fields: {
            type: Array,
            default: () => [
                { key: 'msisdn', label: 'MSISDN' },
                { key: 'icc_id', label: 'ICCID' },
                // { key: 'cliente_full_name', label: 'Propietario' },
                { key: 'planName', label: 'Oferta' },
                { key: 'acciones', label: 'Acciones' }
            ]
        }
    },

    data() {
        return {
            currentStep: 1,
            stripe: null,
            card: null,
            misProductos: [],
            paquetesDisponibles: [],
            selectedPaquete: null,
            cantidad: 1,
            filter: '',
            productoSeleccionado: {
                id: null,
                msisdn: null,
                icc_id: null,
                ofertaspublicas_id: null,
                precio_compra: null,
                estatus: null,
                usuarios_id: null,
                imagenes_id: null,
                created: null,
                modified: null,
                planName: null,
                ofertaspublicas_id_label: null,
                email: null,
                usuarios_id_label: null,
                cliente_full_name: null,
                cliente_full_name_reversed: null
            },
            stripe: null,
            stripeElements: null,
            stripeCardElement: null,
            stripePaymentMethod: null,
            paymentMethod: null,
            isProcessing: false,
            isCompatible: false // Nueva propiedad para confirmar compatibilidad
        }
    },

    computed: {
        markedDescription() {
            let desc = this.selectedProductObj.descr
            if (!desc) {
                return ''
            } else {
                let html = (marked((desc)))
                return (!this.nonSanitized) ? sanitizeHtml(html) : html;
            }
        },
        subtotal() {
            let precio = this.selectedProductObj.precio;
            return precio * this.cantidad;
        },
        selectedProductObj() {
            let f = _.find(this.paquetesDisponibles, (item) => {
                return (parseInt(item.value) == parseInt(this.selectedPaquete))
            });
            if (f)
                return f.fullObj
            else
                return {
                    precio: 0,
                    imagenes_id: null,
                    descr: null
                }
        }
    },

    methods: {
        loadPaymentElements() {
            if (!this.stripe)
                this.stripe = stripeObj.initialize()
            this.stripeElements = this.stripe.elements({
                mode: 'subscription',
                currency: 'mxn',
                amount: (this.subtotal * 100)
            });
            this.stripeCardElement = this.stripeElements.create('card', { style: stripeObj.style });
            this.$nextTick(() => {
                setTimeout(() => {
                    this.stripeCardElement.mount('#' + this.stripeCardElementId);
                }, 200)
            })
        },
        verDetalles(producto) {
            this.productoSeleccionado = producto
            this.$bvModal.show('modal-detalles')
        },
        async loadMyEsims() {
            if(!this.buttonOnly)
                return;
            try {
                const response = await axios.get(this.apiLoadUp)
                this.misProductos = response.data
            } catch (error) {
                console.error('Error al cargar productos:', error)
                this.$bvToast.toast('Error al cargar productos', {
                    title: 'Error',
                    variant: 'danger'
                })
            }
        },
        async cargarPaquetesALaVenta() {
            try {
                const response = await axios.get('ventasesim/disponibles')
                if (!response.data.disponibles.length)
                    throw 'No hay paquetes disponibles';
                this.paquetesDisponibles = response.data.disponibles.map(paquete => ({
                    value: paquete.id,
                    text: `${paquete.planName} - $${paquete.precio}`,
                    fullObj: paquete
                }))
                stripeObj.setStripePublicKey(response.data.stripePublicKey)
            } catch (error) {
                console.error('Error al cargar paquetes:', error)
                this.$bvToast.toast('Error al cargar paquetes disponibles', {
                    title: 'Error',
                    variant: 'danger'
                })
            }
        },
        async processPMObj() {

            const result = await this.stripe.createPaymentMethod({
                type: 'card',
                card: this.stripeCardElement,
            })

            if (result.error) {
                // Handle error
                this.paymentMethod = null;
                console.warn(result.error)
                throw result.error.message;
            } else {
                // PaymentMethod created successfully
                console.log(result.paymentMethod);
                this.paymentMethod = result.paymentMethod;
                // Send paymentMethod.id to your server
            }
            return this.paymentMethod;
        },
        async procesarCompra() {
            try {
                const paymentMethod = await this.processPMObj(),
                    response = await axios.post('ventasesim/comprar', {
                        paquete: this.selectedPaquete,
                        cantidad: this.cantidad,
                        paymentMethod: paymentMethod.id
                    })
                if (response.status) {
                    this.$bvToast.toast(response.msg, {
                        title: 'Éxito',
                        variant: 'success'
                    })
                    this.$emit('refresh')
                    await this.loadMyEsims()
                    this.$bvModal.hide('modal-nuevo-producto')
                }
            } catch (error) {
                console.error('Error al procesar compra:', error)
                notify(error)
                // this.$bvToast.toast(error, {
                //     title: 'Error al procesar la compra',
                //     variant: 'danger'
                // })
            }
        }
    },

    async mounted() {
        await this.loadMyEsims()
        await this.cargarPaquetesALaVenta()
    }
}
</script>

<style lang="scss">
#ventas-esim {}
</style>

<style scoped>
.modal-detalles-img {
    width: 100%;
    max-width: 10em;
    display: block;
    margin: 1em auto;
}
</style>